import * as tconst from "../../Common/Constants";

/**
 * Returns a new Date object set to the iteration start time (hours from tconst.START_TIME, minutes 0).
 */
export function getIterationStart(sDate: Date): Date {
    const _date = new Date(sDate); // Avoid mutating the input date
    _date.setHours(tconst.START_TIME, 0, 0, 0);
    return _date;
}

/**
 * Returns a new Date object set to the iteration end time (hours from tconst.END_TIME, minutes 0).
 */
export function getIterationEnd(eDate: Date): Date {
    const _date = new Date(eDate); // Avoid mutating the input date
    _date.setHours(tconst.END_TIME, 0, 0, 0);
    return _date;
}